<template>
  <div class="home_page">
    <el-header class="right-menu-name" height="20px">
      <!-- 个人中心/{{$route.meta.title}} -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="tabs">
      <div
        v-for="item in tabList"
        :key="item.key"
        :class="
          's2b-tab-item ' + (item.active ? 'tab-item-active' : '')
        "
        @click="changeStatusHandle(item.key)"
      >
        {{ item.lable }}
      </div>
    </div>
    <div class="inquiry-cart">
      <el-table v-loading="dataListLoading"
                :data="dataList"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%; max-width: 100%;">
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"></el-table-column>
        <el-table-column prop="img"
                         label=""
                         header-align="center"
                         align="center"
                         width="140">
          <template slot-scope="scope">
            <img :src="scope.row.fileUrls" alt="" width="100px" height="100px" class="fit-contain">
          </template>
        </el-table-column>
        <el-table-column prop="goodsName"
                         label="商品"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span class="goodsName" @click="goodDetail(scope.row)">{{scope.row.goodsName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="model"
                         label="型号"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column prop="goodsNum"
                         label="数量"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.goodsNum" @change="(val, oldVal) => handleChangeCount(scope.row)" :min="1" :max="999999999" :precision="0" size="small"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="model"
                         label="操作"
                         header-align="center"
                         align="center"
                         width="60">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fix">
        <div class="left">
          <el-checkbox v-model="allCheck"
                        class="check-all"
                        :disabled="!dataList.length"
                        @change="handleCheckAllChange">全选</el-checkbox>
          <span @click="handleDeleteChoosed()">删除选中商品</span>
          <span @click="clearShoppingCart()">清空询价篮</span>
        </div>
        <div class="fix_right">
          <div class="div1">
            已选择 <span class="red">&nbsp;{{ selectGoods }}&nbsp;</span> 件商品
          </div>
          <el-button class="div3"
                    type="primary"
                    plain
                    :disabled="!dataList.length"
                    @click="settlement">询价</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
export default {
  name: 'myInquiryCart', // 询价篮
  data () {
    return {
      dataList: [],
      // expiredList: [], // 过期商品列表
      dataListLoading: false,
      multipleSelection: [], // 多选数组
      allCheck: false, // 全选
      tabList: [
        {
          key: '1',
          lable: '询价单',
          active: true
        },
        {
          key: '2',
          lable: '选型'
        }
      ]
    }
  },
  // filters: {
  //   fomartRowMoney (row) {
  //   }
  // },
  computed: {
    selectGoods () {
      let totalNum = 0
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(shopItem => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          totalNum += row.goodsNum
        }
      })
      return totalNum // Math.round(totalPrice * 100) / 100
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    changeStatusHandle (val) {
      if (val === '1') {
        this.$router.push({
          name: 'myInquiryCart'
        })
      } else {
        this.$router.push({
          name: 'lectotypeCart'
        })
      }
    },
    // 获取当前用户的购物车列表
    getDataList () {
      this.dataList = []
      // this.expiredList = []
      this.multipleSelection = []
      this.$request.get(`/front/consumer/inquirysheet/myInquirySheetCartList`)
        .then(data => {
          this.dataList = data || []
          this.allCheck = false
          this.handleCheckAllChange(false)
          // this.expiredList = data.unavailable || []
        })
    },
    // 表格多选
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === this.dataList.length && val.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    // 底部全选
    handleCheckAllChange (val) {
      if (val) {
        this.$refs.multipleTable.toggleAllSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 更改购物车数量
    handleChangeCount (row) {
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/shoppingcart/updateShoppingCart`, {
        shoppingCartId: row.shoppingCartId,
        goodsNum: row.goodsNum
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.getDataList()
            return
          }
          this.$message.success('加入成功')
          // this.dataList = data || []
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 删除一行数据
    deleteHandle (row) {
      this.deleteShoppingCartGood([row.shoppingCartId])
    },
    // 删除已选中的商品
    handleDeleteChoosed () {
      this.deleteShoppingCartGood(this.multipleSelection.map(item => {
        return item.shoppingCartId
      }))
    },
    // 清空购物车
    clearShoppingCart () {
      this.deleteShoppingCartGood(this.dataList.map(item => {
        return item.shoppingCartId
      }))
    },
    // 删除购物车信息
    deleteShoppingCartGood (ids = []) {
      if (ids.length === 0) {
        return this.$message.warning('请选择要删除的商品')
      }
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/shoppingcart/deleteShoppingCart`, ids)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.getDataList()
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    goodDetail (goods) {
      openOther(`goodDetail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}`)
    },
    // 结算 跳转订单页面
    settlement () {
      if (this.dataListLoading) {
        return
      }
      this.multipleSelection.map(item => {
        return item.shoppingCartId
      })
      if (!this.multipleSelection.length) {
        return this.$message.warning(this.$t('message.selectData'))
      }
      let shoppingCartFormList = []
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(ele => {
          return ele.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          shoppingCartFormList.push(
            item.goodsSpuId + ',' + item.goodsSkuId + ',' + item.goodsNum
          )
        }
      })
      if (shoppingCartFormList.length) {
        this.$router.push({
          name: 'inquiryCreate',
          query: {
            goodList: shoppingCartFormList.join(';'),
            inquiryCart: true
          }
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.home_page{
  .right-menu-name{
    margin: 20px 0;
    padding: 0;
  }
  .inquiry-cart{
    width: 100%;
    background: #fff;
    padding: 15px 35px 30px;
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .goodsName{
      color: #1e64a9;
      cursor: pointer;
    }
    .fix {
      display: flex;
      justify-content: space-between;
      height: 50px;
      background-color: #eeeeee;
      .left {
        line-height: 50px;
        flex-shrink: 0;
        .check-all {
          margin-left: 15px;
        }
        span {
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .fix_right{
        display: flex;
        // justify-content: flex-end;
      }
      .div1 {
        width: 140px;
        .red {
          font-weight: bold;
          color: red;
        }
      }
      .div2 {
        margin-left: 40px;
        width: 150px;
        .red {
          font-weight: bold;
          font-size: 15px;
          color: red;
        }
        .discount {
          text-decoration: line-through;
          color: #aaaaaa;
        }
      }
      .div3 {
        width: 141px;
        margin-left: 20px;
        color: #fff;
        background-color: #1e64a9;
        font-size: 18px;
      }
    }
  }
}
.tabs {
  margin: 0;
  border-bottom: 3px solid #0064c0;
  .s2b-tab-item {
    padding: 0 20px;
    color: #0064c0;
    background: none;
    height: 48px;
    line-height: 48px;
    margin-left: 0;
  }
  .tab-item-active {
    background: #0064c0;
    color: #fff;
  }
}
</style>
